export default "__VITE_ASSET__BajQdUL2__"